// extracted by mini-css-extract-plugin
module.exports = {"link":"navLink-module--link--U09L6","firstLink":"navLink-module--firstLink--2FgKC"};